export function getAppRouteDataLoadPlan(pathname = '', { isAdmin = false } = {}) {
  const path = String(pathname || '/').split(/[?#]/, 1)[0].replace(/\/+$/, '') || '/';
  const administrationHome = path === '/administratie';
  const administrationSection = path.startsWith('/administratie/');
  const adminPanelLoadsMeldingen = Boolean(
    administrationHome
    || (administrationSection && (path !== '/administratie/meldingen' || isAdmin))
  );
  return {
    homeOverview: path === '/',
    analytics: path.startsWith('/analytics/'),
    profileDetails: path === '/profile',
    partsInventory: path === '/profile' || path === '/analytics/onderdelen',
    skipGlobalMeldingen: adminPanelLoadsMeldingen,
  };
}
